export default __webpack_public_path__ + "static/media/lesson-pic3.76d5cfea.jpg";